var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.14A10.01 10.01 0 0112.14 2 10.01 10.01 0 112 12.14zm16.15 5.64A8.43 8.43 0 0020.46 12c0-4.67-3.8-8.47-8.48-8.46a8.52 8.52 0 00-8.44 8.6 8.43 8.43 0 002.31 5.64.2.2 0 00.23-.06c.43-.57.96-1.05 1.55-1.43A8.16 8.16 0 0112 15.08c1.6 0 3.14.43 4.37 1.21a5.97 5.97 0 011.62 1.48.2.2 0 00.16.01zM9.59 7.62c.6-.65 1.46-1 2.41-1 .94 0 1.8.35 2.41 1 .62.66.92 1.54.85 2.5-.14 1.88-1.6 3.42-3.26 3.42-1.66 0-3.12-1.54-3.26-3.43-.07-.96.24-1.85.85-2.5z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.0d3673a3c970c3fd5931b5bc1b796ca5.svg";